<template>
    <TextButton title="Adressbuch" link="/contacts" id="contacts-subnavigationTitle" />
    <div class="my-1 flex flex-wrap justify-between">
        <div class="lg:w-1/2 w-full">
            <FullButton
                title="Neuen Kontakt erfassen"
                @click="createNewContact()"
                width="95"
                colour="red"
                id="contacts-subnavigationButton1"
            />
        </div>
        <div class="lg:w-1/2 w-full text-right">
            <FullButton
                title="Erweiterte Suche"
                link="/contacts/search"
                width="95"
                colour="red"
                id="contacts-subnavigationButton2"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import FullButton from '@/components/Buttons/FullButton.vue'
    import TextButton from '@/components/Buttons/TextButton.vue'
    import useContactStore from '@/utils/useContactStore'
    import router from '@/router'

    const { selectedContact } = useContactStore()

    function createNewContact() {
        selectedContact.value = {}
        selectedContact.value.person = {}
        selectedContact.value.organisation = {}
        selectedContact.value.billing = {}

        router.push('/contacts/edit/0')
    }
</script>
